var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2419_1974)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2419_1974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92425 18.4482L5.17725 20.9302L5.29525 15.5202C5.30275 15.1597 5.4093 14.8082 5.60325 14.5042L13.8222 1.58818C13.9575 1.37366 14.1449 1.19693 14.367 1.07452C14.5891 0.952099 14.8386 0.887991 15.0922 0.888184H16.9352C17.2263 0.888385 17.5111 0.972931 17.7551 1.13159C17.9991 1.29025 18.192 1.51623 18.3102 1.78218L19.0222 3.38818C19.1236 3.61491 19.167 3.86326 19.1487 4.11093C19.1304 4.35859 19.0508 4.59784 18.9172 4.80718L10.6772 17.7582C10.4912 18.0503 10.2315 18.2883 9.92425 18.4482V18.4482Z",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4592 1.47998L9.06519 14.674",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2442 17.8352L9.54419 16.0852C9.39098 15.7016 9.12128 15.3756 8.77307 15.1534C8.42485 14.9311 8.01568 14.8237 7.60319 14.8462L5.69019 14.9462",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2419_1974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.698242 0.40918)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2419_1974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.932,
    height: 21,
    fill: "white",
    transform: "translate(4.69824 0.40918)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.43d272577d271107587ab4eb0a7690d2.svg";
export { ForwardRef as ReactComponent };